import { render, staticRenderFns } from "./sub-category-add.vue?vue&type=template&id=198a295a&"
import script from "./sub-category-add.vue?vue&type=script&lang=js&"
export * from "./sub-category-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports